import { get } from '../httpClient';

/**
 * What a call-to-action can point at (server/api/cta/targets.js).
 */
export const ctaAPI = {
  targets: orgId => get(orgId ? `/api/org/${orgId}/cta-targets` : '/api/creator/cta-targets'),
  // Click totals for Insights over the last `days` days.
  clicks: (orgId, days) =>
    get(orgId ? `/api/org/${orgId}/cta-clicks` : '/api/creator/cta-clicks', { days }),
};
